import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';

const GoogleSignIn = ({ onSuccess }) => {
  const { login, user, logout } = useAuth();
  const [error, setError] = useState(null);

  const handleSuccess = async (credentialResponse) => {
    setError(null);
    const result = await login(credentialResponse.credential);
    
    if (result.success) {
      if (onSuccess) {
        onSuccess();
      }
    } else {
      setError(result.error || 'Login failed');
    }
  };

  const handleError = () => {
    setError('Google sign-in failed. Please try again.');
  };

  if (user) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '10px',
        padding: '10px',
        background: '#f5f5f5',
        borderRadius: '5px'
      }}>
        <span>👤 {user.name || user.email}</span>
        <button 
          onClick={logout}
          style={{
            padding: '5px 15px',
            background: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '3px',
            cursor: 'pointer'
          }}
        >
          Sign Out
        </button>
      </div>
    );
  }

  return (
    <div>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        useOneTap={false}
        theme="outline"
        size="large"
        text="signin_with"
      />
      {error && (
        <div style={{ 
          color: '#dc3545', 
          marginTop: '10px',
          fontSize: '14px'
        }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default GoogleSignIn;

